module.exports = __webpack_public_path__ + "img/client-logo.944d14f2.png";